<template>
  <div class="solution">
    <umf-header style="position: absolute;"  @changeId="changeId"></umf-header>
    <div class="banner">
      <div class="row">
        <h4>
          <img src="~images/solution/block/banner-text.png"
               alt="">
        </h4>
        <p>鑫毅数科数字化行业解决方案， </p>
        <p>以技术创新服务金融和实体产业，</p>
        <p>助力各行业数字转型、智能升级、融合创新。</p>
      </div>
    </div>
    <div class="nav-box clearfix">
      <div class="row">
        <ul>
          <li :class="{active: id == 0}" @click="btnLi(0)">数字政务解决方案</li>
          <li :class="{active: id == 1}" @click="btnLi(1)">非现场监管解决方案</li>
          <li :class="{active: id == 2}" @click="btnLi(2)">供应链金融解决方案</li>
        </ul>
      </div>
    </div>
    <div class="page">

      <div class="page-box"
           style="display:block;margin-bottom:100px;" v-if="id==0">
        <div class="page-one">
          <div class="row">
            <h3>方案简介</h3>
            <div class="center-bg boxBg1">
              <div class="text-box">
                <h4>数字政务解决方案</h4>
                <p>结合区块链可信存储技术，以及知识图谱、AI算法，将政府管理经验、管理方法与海量数据融合，利用区块链分布式存储、时间戳验证等技术保证数据跨地区、跨部门、跨层级、跨业务协同，建设“数字化社会平台”，实现政务能力数字化、智能化，助力政府部门提高政务数据互通和业务协同效率，建设数字化服务型新型社会治理体系。 </p>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="page-box" style="display:block;margin-bottom:100px;"  v-if="id==1">
        <div class="page-one">
          <div class="row">
            <h3>方案简介</h3>
            <div class="center-bg boxBg2">
              <div class="text-box"
                   style="margin-top: 95px;">
                <h4>非现场监管解决方案</h4>
                <p>利用区块链的分布式架构，以开放式的架构和全局性的共识机制降低风险、降低监管成本，结合大数据规则引擎和风险事件驱动预警模型，使非现场监管更实时、精准、可知、可控、可靠。</p>
              </div>
            </div>
          </div>
        </div>
        <div class="page-two">
          <div class="row">
            <h3>应用案例</h3>
            <div class="center-box">
              <ul>
                <li>
                  <img src="~images/solution/icon1.png"
                       alt="">
                  <p>全国首条地方金融风险防控链 </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="page-box" style="display:block;margin-bottom:100px;"  v-if="id==2">
        <div class="page-one">
          <div class="row">
            <h3>方案简介</h3>
            <div class="center-bg boxBg3">
              <div class="text-box">
                <h4>供应链金融解决方案</h4>
                <p>基于自主研发的联盟区块链底层框架Uchains，鑫毅数科打造了标准化、可拓展的供应链金融平台，供应商（融资需求方）、核心企业、资金方、第三方机构等各参与方可以低成本地接入，将应收账款、数字仓单等资产数字化，形成商证e单，通过商证e单的流转把链主信用外延到整个产业链，完成信用流转，解决企业间互信、融资贵和融资难的问题，升级传统供应链金融系统。</p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <umf-footer :topBanner='1'></umf-footer>

  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import UmfHeader from '@/components/umfHeader'
import umfFooter from '@/components/umfFooter'
import vueSeamlessScroll from 'vue-seamless-scroll'
import $ from 'jquery'
export default {
  components: {
    UmfHeader,
    umfFooter
  },

  computed: {

  },
  data () {
    return {
      id: 0
    }
  },
  created () {
    if(this.$route.query.id) {
      this.id = this.$route.query.id
    }
  },
  mounted () {
    
    /* if (this.id) {
      $('.page .page-box').eq(this.id).fadeIn().siblings().fadeOut()
      $('.nav-box ul li').eq(this.id).addClass('active').siblings().removeClass('active')
    }

    let _this = this
    $('.nav-box ul li').on('click', function () {
      $(this).addClass('active').siblings().removeClass('active')
      let index = $(this).index()
      $('.page .page-box').eq(index).fadeIn().siblings().fadeOut()
    }) */
  },
  methods: {
    changeId(id) {
      console.log('传子', id);
      
      this.id = id
    },
    btnLi(id) {
      this.id = id
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/solution/solution.scss";

.solution {
  .banner {
    background-image: url(~images/solution/block/banner.png);
  }
  .nav-box {
    ul {
      li {
        width: 33%;
      }
    }
  }
  .page {
    .page-box {
      .boxBg1 {
          background-image: url(~images/solution//block/center-bg1.png);
      }
      .boxBg2 {
          background-image: url(~images/solution//block/center-bg2.png);
      }
      .boxBg3 {
          background-image: url(~images/solution//block/center-bg3.png);
      }
    }
  }
}
</style>

